import React from "react"
import { FaChevronDown } from "react-icons/fa"

import classes from "./DpBottomButtons.module.scss"

const DpBottomButtons = props => {
  const {
    type,
    timeRangeStep,
    timeRange,
    setTimeRange,
    selectedTime,
    setSelectedTime
  } = props

  const handleDecreaseHour = () => {
    const hourNumber = Number(selectedTime.hours)
    let newHour = hourNumber - 1
    newHour = newHour < 0 ? 23 : newHour
    if (newHour < 10) newHour = `0${newHour}`

    setSelectedTime(prev => ({ ...prev, hours: newHour }))
  }

  const handleDecreaseMinute = () => {
    const minuteNumber = Number(selectedTime.minutes)
    let newMinutes = minuteNumber - 1
    newMinutes = newMinutes < 0 ? 59 : newMinutes
    if (newMinutes < 10) newMinutes = `0${newMinutes}`

    setSelectedTime(prev => ({ ...prev, minutes: newMinutes }))
  }

  const handleDecreaseHourRange = () => {
    const index = timeRangeStep === "start" ? 0 : 1

    const hourNumber = Number(timeRange[index].hours)
    let newHour = hourNumber - 1
    newHour = newHour < 0 ? 23 : newHour
    if (newHour < 10) newHour = `0${newHour}`

    setTimeRange(prev => {
      const array = [...prev]
      array[index].hours = newHour
      return array
    })
  }

  const handleDecreaseMinuteRange = () => {
    const index = timeRangeStep === "start" ? 0 : 1

    const minuteNumber = Number(timeRange[index].minutes)

    let newMinutes = minuteNumber - 1
    newMinutes = newMinutes < 0 ? 59 : newMinutes

    if (newMinutes < 10) newMinutes = `0${newMinutes}`

    setTimeRange(prev => {
      const array = [...prev]
      array[index].minutes = newMinutes
      return array
    })
  }

  return (
    <div className={classes["row"]}>
      <div
        onClick={
          type === "rangeTimePicker"
            ? handleDecreaseHourRange
            : handleDecreaseHour
        }
        className={classes["button"]}
      >
        <FaChevronDown />
      </div>
      <div
        className={classes["button"]}
        onClick={
          type === "rangeTimePicker"
            ? handleDecreaseMinuteRange
            : handleDecreaseMinute
        }
      >
        <FaChevronDown />
      </div>
    </div>
  )
}

export default DpBottomButtons